import {
  PRINT_QUOTATION,
} from './constants';

export const printQuotation = code => ({
  type: PRINT_QUOTATION,
  code,
});
